import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex w-full overflow-hidden" }
const _hoisted_2 = { class: "flex border-brand-dark-gray justify-between ml-4 w-full overflow-hidden" }
const _hoisted_3 = { class: "flex space-x-2 overflow-hidden w-full my-auto" }
const _hoisted_4 = { class: "text-white font-medium text-lg my-auto truncate" }
const _hoisted_5 = { class: "flex" }

import {computed, PropType, provide, ref} from "vue";
import {FriendUserInterface} from "@/interfaces/FriendUserInterface";
import ApiService from "@/services/api/apiService";
import {Observable, ObservableEvent} from "@/services/observable/Observable";
import {useIonRouter} from "@ionic/vue";
import UserVerificationCheck from "@/components/UserBadges.vue";
import {UserBasicInformationInterface} from "@/interfaces/UserBasicInformationInterface";
import {ChatParticipantInterface} from "@/interfaces/ChatParticipantInterface";
import UserAvatar from "@/components/UserAvatar.vue";



export default /*@__PURE__*/_defineComponent({
  __name: 'UserListItem',
  props: {
  user: {
    type: Object as PropType<UserBasicInformationInterface | ChatParticipantInterface>,
    required: true
  }
},
  setup(__props) {


const props = __props



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(UserAvatar, { user: __props.user }, null, 8, ["user"]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, _toDisplayString(__props.user.name), 1),
        _createElementVNode("div", _hoisted_5, [
          _createVNode(UserVerificationCheck, { user: __props.user }, null, 8, ["user"])
        ])
      ])
    ])
  ]))
}
}

})